import api from './config';

export const createEssayOrder = async (orderData) => {
  try {
    console.log('Sending order data:', orderData);
    const isFormData = orderData instanceof FormData;
    
    const response = await api.post('/orders/essays/', orderData, {
      headers: isFormData ? {
        'Content-Type': 'multipart/form-data'
      } : {
        'Content-Type': 'application/json'
      }
    });
    console.log('Order response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Full error object:', error);
    console.error('Error response:', error.response);
    console.error('Error response data:', error.response?.data);
    throw error.response?.data || error.message;
  }
};
    

export const getOrder = async (orderId) => {
  try {
    const response = await api.get(`/orders/essays/${orderId}/`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const createCourseworkInquiry = async (inquiryData) => {
  try {
    const payload = {
      email: inquiryData.email,
      course_name: inquiryData.courseName,
      duration: inquiryData.duration,
      assignments: inquiryData.assignments,
      additional_info: inquiryData.additionalInfo,
    };
    const response = await api.post('/orders/coursework/', payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const createPayment = async (orderId) => {
  try {
    console.log('Creating payment for order:', orderId);
    const response = await api.post('/payments/create/', { order_id: orderId });
    console.log('Payment response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Payment error:', error);
    console.error('Payment error response:', error.response?.data);
    throw error.response?.data || error.message;
  }
};

export const executePayment = async (paymentId, payerId, orderId) => {
  try {
    const response = await api.post('/payments/execute/', {
      payment_id: paymentId,
      payer_id: payerId,
      order_id: orderId,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};